/**
 * Admin 사용자 관리. 라우트 admin.php users 그룹과 동기화.
 * edit: 프로필 이미지 선택 시 미리보기 갱신.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

function edit(): void {
    initUserEditTabs();

    const wrap = document.querySelector("[data-user-avatar-upload]");
    if (!wrap) return;
    const input = wrap.querySelector<HTMLInputElement>("[data-avatar-input]");
    const preview = wrap.querySelector("[data-avatar-preview]");
    if (!input || !preview) return;

    let previousBlobUrl: string | null = null;
    input.addEventListener("change", () => {
        const file = input.files?.[0];
        if (!file || !file.type.startsWith("image/")) {
            if (!file) {
                const initial = preview.querySelector("[data-avatar-initial]");
                const img = preview.querySelector("img");
                if (img) img.remove();
                if (initial) (initial as HTMLElement).style.display = "";
            }
            return;
        }
        if (previousBlobUrl) URL.revokeObjectURL(previousBlobUrl);
        const url = URL.createObjectURL(file);
        previousBlobUrl = url;
        const img = preview.querySelector("img");
        const initial = preview.querySelector("[data-avatar-initial]");
        if (img) {
            img.src = url;
            (img as HTMLImageElement).style.display = "";
        } else {
            const newImg = document.createElement("img");
            newImg.src = url;
            newImg.alt = "";
            newImg.width = 80;
            newImg.height = 80;
            newImg.className = "admin-form__avatar-img";
            preview.innerHTML = "";
            preview.appendChild(newImg);
        }
        if (initial) (initial as HTMLElement).style.display = "none";
    });
}

function initUserEditTabs(): void {
    const tabBtns = document.querySelectorAll(".admin-user-edit-tabs__tab");
    const panels = document.querySelectorAll(".admin-user-edit-panel");
    if (!tabBtns.length || !panels.length) return;

    tabBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const tabKey = btn.getAttribute("data-tab") ?? "";
            panels.forEach((p) => {
                const panelId = p.id ?? "";
                const isActive = panelId === "user-edit-panel-" + tabKey;
                (p as HTMLElement).classList.toggle("admin-user-edit-panel--hidden", !isActive);
            });
            tabBtns.forEach((b) => {
                const key = b.getAttribute("data-tab") ?? "";
                b.classList.toggle("admin-user-edit-tabs__tab--active", key === tabKey);
                b.setAttribute("aria-selected", key === tabKey ? "true" : "false");
            });
        });
    });
}

export const UserController = {
    index(): void {
        noop("UserController", "index");
    },
    create(): void {
        noop("UserController", "create");
    },
    store(): void {
        noop("UserController", "store");
    },
    edit,
    update(): void {
        noop("UserController", "update");
    },
    showPasswordChangeForm(): void {
        noop("UserController", "showPasswordChangeForm");
    },
    changePassword(): void {
        noop("UserController", "changePassword");
    },
    showForgotPasswordForm(): void {
        noop("UserController", "showForgotPasswordForm");
    },
    forgotPassword(): void {
        noop("UserController", "forgotPassword");
    },
    resetPassword(): void {
        noop("UserController", "resetPassword");
    },
};
